import { OrganizationReportAccountEncryptionAndDecryptionEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const OrganizationReportAccountEncryptionAndDecryptionResource = authResource({
    path: '/organizations/:organizationId/reports/accounts/encryptionsanddecryptions/:encryptionsanddecryptionsId?',
    searchParams: {},
    schema: OrganizationReportAccountEncryptionAndDecryptionEntity
}).extend('getList', {
    schema: paginatedSchema(OrganizationReportAccountEncryptionAndDecryptionEntity)
});
